import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from '../../base.component';
import {FilterUtil} from '../../../util/filter.util';
import {RequestType} from '../../../enums/request.type';
import {ListResponse} from '../../../network/service/list.response';
import {SnackBarUtil} from '../../../util/snack.bar.util';
import {VerifyOptions} from '../../dialog/verify/options/verify.options';
import {VerifyComponent} from '../../dialog/verify/verify.component';
import {DataResponse} from '../../../network/service/data.response';
import {AddOrUpdateAdditiveOptions} from '../dialog/add-or-update-additive/options/add-or-update-additive.options';
import {AddOrUpdateAdditiveComponent} from '../dialog/add-or-update-additive/add-or-update-additive.component';

@Component({
  selector: 'app-additives',
  standalone: false,
  templateUrl: './additives.component.html',
  styleUrl: './additives.component.scss'
})
export class AdditivesComponent extends BaseComponent implements OnInit {
  displayedColumns = ['Update', 'Delete', 'Title', 'Type', 'MaxChoice', 'IsActive',];
  displayDataSources = ['edit', 'delete', 'Title', 'Type', 'MaxChoice', 'IsActiveIcon'];
  displayColumnTypes = ['event', 'event', 'string', 'string', 'string', 'icon'];
  displayEndPoint = ['', ''];
  additives: any = [];
  allFilters = FilterUtil.DeliveryMethodsFilters;
  filters: any = {};

  constructor(injector: Injector) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override loadOnline() {
    super.loadOnline();
    this.serviceApi.getAdditives(this.tableProperties.offset, this.tableProperties.limit, '', RequestType.PAGINATE, undefined, {
      Filter: this.filters,
    }).subscribe((res: ListResponse<any>) => {
      if (res.success) {
        this.additives = res.data;
        this.tableProperties.pageLength = res.count;
        this.setListeners();
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }

  override setListeners() {
    super.setListeners();
    if (this.additives) {
      for (let i = 0; i < this.additives.length; i++) {
        this.additives[i].edit = (index: number) => {
          this.onUpdateClicked(index);
        };
        this.additives[i].delete = (index: number) => {
          this.onDeleteClicked(index);
        };
        if (this.additives[i].IsActive === true) {
          this.additives[i].IsActiveIcon = 'check_circle-green';
        } else {
          this.additives[i].IsActiveIcon = 'do_not_disturb-red';
        }
      }
    }
  }

  override pageChanged(event: any) {
    super.pageChanged(event);
    this.tableProperties.offset = (event.pageIndex);
    this.loadOnline();
  }

  override onSortChanged(event: any) {
    super.onSortChanged(event);
    this.loadOnline();
  }

  onFiltersChanged(filters: any) {
    this.filters = filters;
    this.tableProperties.offset = 0;
    this.loadOnline();
  }

  onCreateClicked() {
    let addOrUpdateAdditiveOptions = new AddOrUpdateAdditiveOptions();
    addOrUpdateAdditiveOptions.additive = {};
    addOrUpdateAdditiveOptions.onInsertOrUpdateFinished = () => {
      this.loadOnline();
    };
    let addOrUpdateAdditiveComponent = this.matDialog.open(AddOrUpdateAdditiveComponent, {
      height: 'auto',
      width: '100%',
      direction: "rtl"
    });
    addOrUpdateAdditiveComponent.componentInstance.addOrUpdateAdditiveOptions = addOrUpdateAdditiveOptions;
  }

  onUpdateClicked(index: number) {
    let addOrUpdateAdditiveOptions = new AddOrUpdateAdditiveOptions();
    addOrUpdateAdditiveOptions.additive = this.additives[index];
    addOrUpdateAdditiveOptions.onInsertOrUpdateFinished = () => {
      this.loadOnline();
    };
    let addOrUpdateAdditiveComponent = this.matDialog.open(AddOrUpdateAdditiveComponent, {
      height: 'auto',
      width: '100%',
      direction: "rtl"
    });
    addOrUpdateAdditiveComponent.componentInstance.addOrUpdateAdditiveOptions = addOrUpdateAdditiveOptions;
  }

  onDeleteClicked(index: number) {
    let verifyOptions = new VerifyOptions();
    verifyOptions.message = 'آیا از حذف درخواست خود مطمئن هستید؟';
    let verifyComponent = this.matDialog.open(VerifyComponent);
    verifyOptions.onNoClicked = () => {
      verifyComponent.close();
    };
    verifyOptions.onYesClicked = () => {
      this.serviceApi.deleteAdditives(this.additives[index].AdditiveId).subscribe((res: DataResponse<any>) => {
        if (res.success) {
          verifyComponent.close();
          this.loadOnline();
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
        }
      });
    };
    verifyComponent.componentInstance.verifyOptions = verifyOptions;
  }
}
